import '@vitejs/plugin-react/preamble'
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import "./finch/components/style.css";
import HubAppLayout from './finch/components/HubAppLayout';

import { AppConfigurationProvider } from './appConfigurationProvider.tsx';
import { CurrentUserProvider } from './currentUserProvider.tsx';
import { MetadataProvider } from './metadataProvider.tsx';
import HomePage from './homePage.tsx';


const root = createRoot(document.getElementById('root')!);

// const base = import.meta.env.BASE_URL;
const base = '/';
// The above resolves to "/static/" as set in vite.config.ts,
// but we should use "/" here to match Django's server behavior.

// Note that the CurrentUserProvider does not render its given children unless the user
// is logged in (it redirects and/or shows a banner instead)
// so when we render MetadataProvider we can assume loggedIn is 'true'.


const homePageIcon = <svg xmlns="http://www.w3.org/2000/svg"
                          width="32" height="32" fill="currentColor" viewBox="0 0 256 256">
                          <path d="M230.91,124A8,8,0,0,1,228,134.91l-96,56a8,8,0,0,1-8.06,0l-96-56A8,8,0,0,1,36,121.09l92,53.65,92-53.65A8,8,0,0,1,230.91,124ZM24,80a8,8,0,0,1,4-6.91l96-56a8,8,0,0,1,8.06,0l96,56a8,8,0,0,1,0,13.82l-96,56a8,8,0,0,1-8.06,0l-96-56A8,8,0,0,1,24,80Zm23.88,0L128,126.74,208.12,80,128,33.26ZM232,192H216V176a8,8,0,0,0-16,0v16H184a8,8,0,0,0,0,16h16v16a8,8,0,0,0,16,0V208h16a8,8,0,0,0,0-16Zm-92,23.76-12,7L36,169.09A8,8,0,0,0,28,182.91l96,56a8,8,0,0,0,8.06,0l16-9.33A8,8,0,1,0,140,215.76Z"></path>
                      </svg>

root.render(
  <StrictMode>
    <AppConfigurationProvider>
      <CurrentUserProvider>
        <MetadataProvider loggedIn={true}>
          <BrowserRouter basename={base}>
            <HubAppLayout
              className="w-full h-full"
              headerLogoUrl={`${import.meta.env.BASE_URL}/alt_spectrum_logo-dark.png`}
              headerTitle="ALS Beamline Owners"
              routes={[
                {
                  element: <HomePage />,
                  icon: homePageIcon,
                  label: 'Access',
                  path: '/'
                },
              ]}
            />
          </BrowserRouter>
        </MetadataProvider>
      </CurrentUserProvider>
    </AppConfigurationProvider>
  </StrictMode>
)
